import { useSession } from 'next-auth/react';
import { getNavigationRedirectPath } from '../lib/navigation-utils';

/**
 * Hook for navigation redirection based on user permissions and role
 * Uses the shared navigation configuration to determine the first accessible route
 */
export const useNavigationRedirect = () => {
  const { data: session } = useSession();

  /**
   * Get the first accessible route for the current user
   * @returns The path to redirect the user to
   */
  const getFirstAccessibleRoute = (): string => {
    if (!session?.user) {
      return '/login';
    }

    const userRole = session.user.role;
    const userPermissions = session.user.permissions || [];

    // Use the shared utility function
    return getNavigationRedirectPath(userRole, userPermissions);
  };

  return { getFirstAccessibleRoute };
};
